module.exports = __webpack_public_path__ + "static/img/静压分风箱.aafa732b.png";